import { render, staticRenderFns } from "./AdminDetectionPoints.vue?vue&type=template&id=63d3d58a&scoped=true"
import script from "./AdminDetectionPoints.vue?vue&type=script&lang=js"
export * from "./AdminDetectionPoints.vue?vue&type=script&lang=js"
import style0 from "./AdminDetectionPoints.vue?vue&type=style&index=0&id=63d3d58a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3d58a",
  null
  
)

export default component.exports